/* eslint-disable no-shadow */

export enum RegularExpressions {
  isAlphabetic = '^[A-Za-z]+$',
  isValidExpirationMonthWithLeadingZeroes = '^(0[123456789]|10|11|12|[123456789])$',
  isValidExpirationMonthWithNoLeadingZeroes = '^([123456789])$',
  isValidOtherAmount = '^\\d+(\\.\\d{1,2})?$',
  isNumeric = '^-?\\d+$',
  isValidNameOrLastName = '^[^&<>%"]+$',
  hasAtLeastOneChar = '[a-zA-Z]',
  isValidUSZipCode = '^[0-9]{5}',
  isValidCanadianPostCode = `^([a-ceghj-npr-tv-z]{1}[0-9]{1}[a-ceghj-npr-tv-z]{1}[\\s]{1}[0-9]{1}[a-ceghj-npr-tv-z]{1}[0-9]{1})$`,
  isValidInternationalPostCode = '^[^&<>"]+$',
  hasSpecialCharactersNotAllowed = '^[^&<>"]*$',
  hasOnlyNumbers = '^\\d+$',
}

export enum Payment_Type {
  PayPal = 'PayPal',
  CreditCard = 'Credit Card',
  DonorAdvisedFund = 'Donor Advised Fund',
}

/* Public Event Type in TR */
export const enum EVENT_TYPE {
  COLLEGIATE = 'collegiate',
  // DIY = 'diy',
  EVENTS = 'events',
  HEROES = 'heroes',
  HOURS = 'hours',
  IRONMAN = 'ironman',
  MATH = 'math',
  MEMORIALS = 'memorials',
  PEORIARUNS = 'peoriaruns',
  PDC = 'pdc',
  RNR = 'rnr',
  SJMMW = 'sjmmw',
  SPECIAL_EVENTS = 'specialevents',
  TAEVENTS = 'taevents',
  TKE = 'tke',
  TRIDELTA = 'tridelta',
  TRIKE = 'trike',
  UTD = 'utd',
  VARSITY = 'varsity',
  WALKRUN = 'walkrun',
  WORK = 'work', // DIY At Work Temporary
  YOU_CHOOSE = 'diy', // DIY Just Because You Choose Temporary
}

export const ASK_ARRAY_SIZES = {
  sm: ['10', '20', '50', '75'],
  md: ['30', '50', '100', '250'],
  lg: ['50', '100', '250', '500'],
};

export const ASK_ARRAY: { [key: string]: string[] } = {
  [EVENT_TYPE.HEROES]: ASK_ARRAY_SIZES.sm,
};

export enum CreditCardType {
  AmericanExpress = 'American Express',
  Visa = 'Visa',
  MasterCard = 'Mastercard',
  Discover = 'Discover',
  Other = '',
}

export enum PaymentSchedule {
  OneTime = 'One Time',
  Monthly = 'Monthly',
}

export enum Country {
  UnitedStates = 'United States',
  Canada = 'Canada',
}

export enum DonationField {
  country = 'country',
  address1 = 'address1',
  address2 = 'address2',
  address3 = 'address3',
  city = 'city',
  state = 'state',
  postCode = 'postCode',

  donorEmail = 'donorEmail',
  donorEmailOptIn = 'donorEmailOptIn',
  firstName = 'firstName',
  lastName = 'lastName',
  donationDisplayName = 'donationDisplayName',
  donationPersonalNote = 'donationPersonalNote',
  hideMyDisplayName = 'hideMyDisplayName',
  hideDonationAmount = 'hideDonationAmount',
  paymentSchedule = 'paymentSchedule',
  donationAmount = 'donationAmount',
  donationOtherAmount = 'donationOtherAmount',
  donationLevelId = 'donationLevelId',
}

/** https://alsacwiki.stjude.org/display/~turners/Form+Field+Error+Messages
 * All messages are static with a couple of exceptions where token substitution is required
 *  Example $low $high tokens for credit card year
 */
export const enum ErrorMessages {
  // Donation Amount
  donationAmountRequired = 'Online donations must be a minimum of $5.',
  donationAmountInvalid = 'Please enter an amount in U.S. currency format (####.##).',
  donationAmountTooLow = 'Online donations must be a minimum of $5.',
  donationAmountTooHigh = 'Please enter an amount less than $2,000,000. If you wish to give more, please call 800-805-5856.',

  // Credit Card
  creditCardRequired = 'Please enter a 15 or 16 digit credit/debit card number. We accept Visa, Mastercard, Discover and American Express cards. ',
  creditCardInvalid = 'Please enter a valid 15 or 16 digit credit/debit card number. We accept Visa, Mastercard, Discover and American Express cards.',
  creditCardMonthRequired = 'Please enter a month between 1 and 12.',
  creditCardMonthInvalid = 'Please enter a month between 1 and 12.',
  creditCardYearRequired = `Please enter a two-digit year between $low and $high.`,
  creditCardPastDate = 'The entered date is in the past. Please enter an expiration date in the future.',
  creditCardYearRange = `Please enter a two-digit year between $low and $high.`,
  creditCardCvvRequired = `Please enter your card's 3 or 4 digit security code.`,
  creditCardCvvInvalid = `Please enter your card's 3 digit security code.`,
  creditCardCvvInvalidAmex = `Please enter your card's 4 digit security code.`,

  // Personal Info
  firstNameRequired = 'Tell us your first name.',
  firstNameInvalid = "Please remove all ' &<>%\" ' characters.",
  firstNameHasAtLeastOneChar = 'Tell us your first name.',
  lastNameRequired = 'Tell us your last name.',
  lastNameInvalid = "Please remove all ' &<>%\" ' characters.",
  lastNameHasAtLeastOneChar = 'Tell us your last name.',
  emailRequired = 'We need your email to send you a receipt.',
  emailInvalid = 'Please correct any errors in your email address.',
  phoneNumberRequired = 'Please enter all numbers for phone number - no dashes or parenthesis.',
  phoneNumberInvalid = 'Please enter all numbers for phone number - no dashes or parenthesis.',
  address1Required = `Don't forget to give us your address.`,
  countryRequired = `Don't forget to add your country.`,
  cityRequired = `Don't forget your city.`,
  stateRequired = `Don't forget to add your state.`,
  provinceRequired = `Don't forget to add your province.`,
  zipCodeRequired = `Don't forget your zip code.`,
  zipCodeInvalid = `Please enter a valid zip code.`,
  postCodeRequired = `Don't forget your postal code.`,
  postCodeInvalid = `Please enter a valid postal code.`,
  internationalPostCodeInvalid = "Please remove all ' &<>\" ' characters.",
  hasSpecialCharactersNotAllowed = "Please remove all ' &<>\" ' characters.",
}

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const US_STATES = [
  {
    code: 'AK',
    description: 'Alaska',
  },
  {
    code: 'AL',
    description: 'Alabama',
  },
  {
    code: 'AR',
    description: 'Arkansas',
  },
  {
    code: 'AZ',
    description: 'Arizona',
  },
  {
    code: 'CA',
    description: 'California',
  },
  {
    code: 'CO',
    description: 'Colorado',
  },
  {
    code: 'CT',
    description: 'Connecticut',
  },
  {
    code: 'DC',
    description: 'District of Columbia',
  },
  {
    code: 'DE',
    description: 'Delaware',
  },
  {
    code: 'FL',
    description: 'Florida',
  },
  {
    code: 'GA',
    description: 'Georgia',
  },
  {
    code: 'HI',
    description: 'Hawaii',
  },
  {
    code: 'IA',
    description: 'Iowa',
  },
  {
    code: 'ID',
    description: 'Idaho',
  },
  {
    code: 'IL',
    description: 'Illinois',
  },
  {
    code: 'IN',
    description: 'Indiana',
  },
  {
    code: 'KS',
    description: 'Kansas',
  },
  {
    code: 'KY',
    description: 'Kentucky',
  },
  {
    code: 'LA',
    description: 'Louisiana',
  },
  {
    code: 'MA',
    description: 'Massachusetts',
  },
  {
    code: 'MD',
    description: 'Maryland',
  },
  {
    code: 'ME',
    description: 'Maine',
  },
  {
    code: 'MI',
    description: 'Michigan',
  },
  {
    code: 'MN',
    description: 'Minnesota',
  },
  {
    code: 'MO',
    description: 'Missouri',
  },
  {
    code: 'MS',
    description: 'Mississippi',
  },
  {
    code: 'MT',
    description: 'Montana',
  },
  {
    code: 'NC',
    description: 'North Carolina',
  },
  {
    code: 'ND',
    description: 'North Dakota',
  },
  {
    code: 'NE',
    description: 'Nebraska',
  },
  {
    code: 'NH',
    description: 'New Hampshire',
  },
  {
    code: 'NJ',
    description: 'New Jersey',
  },
  {
    code: 'NM',
    description: 'New Mexico',
  },
  {
    code: 'NV',
    description: 'Nevada',
  },
  {
    code: 'NY',
    description: 'New York',
  },
  {
    code: 'OH',
    description: 'Ohio',
  },
  {
    code: 'OK',
    description: 'Oklahoma',
  },
  {
    code: 'OR',
    description: 'Oregon',
  },
  {
    code: 'PA',
    description: 'Pennsylvania',
  },
  {
    code: 'RI',
    description: 'Rhode Island',
  },
  {
    code: 'SC',
    description: 'South Carolina',
  },
  {
    code: 'SD',
    description: 'South Dakota',
  },
  {
    code: 'TN',
    description: 'Tennessee',
  },
  {
    code: 'TX',
    description: 'Texas',
  },
  {
    code: 'UT',
    description: 'Utah',
  },
  {
    code: 'VA',
    description: 'Virginia',
  },
  {
    code: 'VT',
    description: 'Vermont',
  },
  {
    code: 'WA',
    description: 'Washington',
  },
  {
    code: 'WI',
    description: 'Wisconsin',
  },
  {
    code: 'WV',
    description: 'West Virginia',
  },
  {
    code: 'WY',
    description: 'Wyoming',
  },
  {
    code: 'AS',
    description: 'American Samoa',
  },
  {
    code: 'FM',
    description: 'Federated States of Micronesia',
  },
  {
    code: 'GU',
    description: 'Guam',
  },
  {
    code: 'MH',
    description: 'Marshall Islands',
  },
  {
    code: 'MP',
    description: 'Northern Mariana Islands',
  },
  {
    code: 'PR',
    description: 'Puerto Rico',
  },
  {
    code: 'PW',
    description: 'Palau',
  },
  {
    code: 'VI',
    description: 'Virgin Islands',
  },
  {
    code: 'AA',
    description: 'Armed Forces the Americas',
  },
  {
    code: 'AP',
    description: 'Armed Forces Pacific',
  },
];

export const CANADA_STATES = [
  {
    code: 'AB',
    description: 'Alberta',
  },
  {
    code: 'BC',
    description: 'British Columbia',
  },
  {
    code: 'MB',
    description: 'Manitoba',
  },
  {
    code: 'NB',
    description: 'New Brunswick',
  },
  {
    code: 'NL',
    description: 'Newfoundland and Labrador',
  },
  {
    code: 'NS',
    description: 'Nova Scotia',
  },
  {
    code: 'NT',
    description: 'Northwest Territories',
  },
  {
    code: 'NU',
    description: 'Nunavut',
  },
  {
    code: 'ON',
    description: 'Ontario',
  },
  {
    code: 'PE',
    description: 'Prince Edward Island',
  },
  {
    code: 'QC',
    description: 'Quebec',
  },
  {
    code: 'SK',
    description: 'Saskatchewan',
  },
  {
    code: 'YT',
    description: 'Yukon',
  },
];

export const COUNTRIES = [
  'United States',
  'Canada',
  'Afghanistan',
  'Aland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivarian Republic of Venezuela',
  'Bonaire, Sint Eustatios and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Cook Islands',
  'Costa Rica',
  "Cote D'Ivoire",
  'Croatia',
  'Cuba',
  'Curacao',
  'Cyprus',
  'Czech Republic',
  "Democratic People's Republic of Korea",
  'The Democratic Republic of the Congo',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Federated States of Micronesia',
  'Fiji',
  'Finland',
  'The Former Yugoslav Republic of Macedonia',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iraq',
  'Ireland',
  'Islamic Republic of Iran',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  "Laos People's Democratic Republic",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Plurinational State of Bolivia',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of Korea',
  'Republic of Moldova',
  'Reunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barthelemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'S. Georgia & S. Sandwich Isls.',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province of China',
  'Tajikistan',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United Republic of Tanzania',
  'Uruguay',
  'USA Minor Outlying Islands',
  'Uzbekistan',
  'Vanuatu',
  'Viet Nam',
  'Virgin Islands (British)',
  'Virgin Islands (USA)',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];
